import { useLayoutEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { Div } from '../../styles';
import Spinner from 'components/Spinner/Spinner';

export const Video = ({ src }) => {
  const [size, setSize] = useState({ width: null, height: null });
  const ref = useRef(null);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    setSize({
      width: ref?.current?.clientWidth,
      height: ref?.current?.clientWidth * (9 / 16),
    });
  }, []);

  return (
    <Div $textAlignCenter $width='100%' $height={size.height} ref={ref}>
      {/* {loading && <Spinner />} */}
      <Div ref={ref} $flex $alignCenter $justifyCenter>
        <ReactPlayer
          onReady={() => setLoading(false)}
          src={src}
          width={size.width}
          height={size.height}
          controls={true}
          style={{ borderRadius: 25 }}
          playing={true}
        />
      </Div>
    </Div>
  );
};
